import { render } from "./product_review.vue?vue&type=template&id=16897132"
import script from "./product_review.vue?vue&type=script&lang=js"
export * from "./product_review.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__